<button [style.width]="width" [class.selected]="selected" [class.flex-grow]="flexGrow" (click)="buttonClick.emit()">
  <img src="assets/img/icons/check-circle-green.svg" />
  <ng-content></ng-content>
</button>
